import { render, staticRenderFns } from "./BaseContentComponent.vue?vue&type=template&id=0cdcb0bb"
import script from "./BaseContentComponent.vue?vue&type=script&lang=js"
export * from "./BaseContentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports